import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const draftUsersAdapter = createEntityAdapter({})
const initialState = draftUsersAdapter.getInitialState()

export const draftUsersApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getDraftUsers: builder.query({
            query: () => ({
                url: '/draftusers',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadeddraftUsers = responseData.map(draftuser => {
                    draftuser.id = draftuser._id
                    return draftuser
                });
                return draftUsersAdapter.setAll(initialState, loadeddraftUsers)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'DraftUser', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'User', id }))
                    ]
                } else return [{ type: 'DraftUser', id: 'LIST' }]
            }
        }),
        addNewDraftUser: builder.mutation({
            query: initialDraftUserData => ({
                url: '/draftusers',
                method: 'POST',
                body: {
                    ...initialDraftUserData,
                }
            }),
            invalidatesTags: [
                { type: 'DraftUser', id: "LIST" }
            ]
        }),       
        updateDraftUser: builder.mutation({
            query: initialDraftUserData => ({
                url: '/draftusers',
                method: 'PUT',
                body: {
                    ...initialDraftUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'DraftUser', id: arg.id }
            ]
        }),
        deleteDraftUser: builder.mutation({
            query: ({ id }) => ({
                url: `/draftusers`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'DraftUser', id: arg.id }
            ]
        })     
    }),
})



export const {
    useGetDraftUsersQuery,
    useAddNewDraftUserMutation,
    useUpdateDraftUserMutation,
    useDeleteDraftUserMutation  
} = draftUsersApiSlice

// returns the query result object
export const selectDraftUsersResult = draftUsersApiSlice.endpoints.getDraftUsers.select()

// creates memoized selector
const selectDraftUsersData = createSelector(
    selectDraftUsersResult,
    usersResult => usersResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUsers,
    selectById: selectUserById,
    selectIds: selectUserIds
    // Pass in a selector that returns the users slice of state
} = draftUsersAdapter.getSelectors(state => selectDraftUsersData(state) ?? initialState)